import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { LeagueRootService } from '@core/services/league-root.service';
import { componentDestroyed, League, UntilDestroy } from '@mtgame/core';
import { takeUntil } from 'rxjs/operators';
import { SeoService } from '@core/services/seo.service';

@UntilDestroy
@Component({
  selector: 'mtg-league-root',
  templateUrl: './league-root.component.html',
  styleUrls: ['./league-root.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeagueRootComponent implements OnInit, OnDestroy {
  league: League;

  constructor(
    private seoService: SeoService,
    private leagueRootService: LeagueRootService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.leagueRootService.league$
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(league => {
        this.league = league;
        this.cdr.markForCheck();
      });
  }

  ngOnDestroy(): void {
  }
}
